import { render, staticRenderFns } from "./realTestStart.vue?vue&type=template&id=2ae0bd78&scoped=true"
import script from "./realTestStart.vue?vue&type=script&lang=js"
export * from "./realTestStart.vue?vue&type=script&lang=js"
import style0 from "./realTestStart.vue?vue&type=style&index=0&id=2ae0bd78&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae0bd78",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae0bd78')) {
      api.createRecord('2ae0bd78', component.options)
    } else {
      api.reload('2ae0bd78', component.options)
    }
    module.hot.accept("./realTestStart.vue?vue&type=template&id=2ae0bd78&scoped=true", function () {
      api.rerender('2ae0bd78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/realTest/realTestStart.vue"
export default component.exports